type TranslateFn = (key: string) => string;

export function getFeedbackStatusLabel(status: string, t: TranslateFn): string {
  const labels: Record<string, string> = {
    PENDING_CONFIRMATION: t('feedbackStatusPendingConfirmation'),
    CONFIRMED: t('feedbackStatusConfirmed'),
    IN_PROGRESS: t('feedbackStatusInProgress'),
    COMPLETED: t('feedbackStatusCompleted'),
    REJECTED: t('feedbackStatusRejected'),
    CANCELLED: t('feedbackStatusCancelled'),
  };
  return labels[status] ?? status;
}

export function getFeedbackPriorityLabel(priority: string, t: TranslateFn): string {
  const labels: Record<string, string> = {
    LOW: t('feedbackPriorityLow'),
    MEDIUM: t('feedbackPriorityMedium'),
    HIGH: t('feedbackPriorityHigh'),
    URGENT: t('feedbackPriorityUrgent'),
  };
  return labels[priority] ?? priority;
}
